import { getRegisterFunction } from '../../utils/register.js';
import { OneUxAvatarElement } from './OneUxAvatarElement.js';
export const register = getRegisterFunction(OneUxAvatarElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-avatar': OneUxAvatarElement;
    "avatar-57a686876050d80245549b49aef12ed8": OneUxAvatarElement;
  }
}